module.exports = __webpack_public_path__ + "img/pin_exchange_purple.064182de.svg";